import { useState } from 'react';
import { Alert, Anchor, Button, Card, Center, Stack, Text, TextInput, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

import { useSession } from '../lib/session';

// The step between a new account and a paired tablet.
//
// A parent who has just confirmed their address belongs to no family yet, and
// nothing else in the app works without one: a child profile, a session and a
// plan all hang off it. This is the only screen that founds one, and it is
// shown exactly when `needsFamily` says so.
export function CreateFamilyPage() {
  const { createFamily, unpair } = useSession();
  const [name, setName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const go = () => {
    setBusy(true);
    setError('');
    void (async () => {
      try {
        await createFamily(name, displayName);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setBusy(false);
      }
    })();
  };

  return (
    <Center mih="100vh" p="md">
      <Card withBorder padding="xl" radius="md" w={420} maw="100%">
        <Stack>
          <Title order={3}>Familie anlegen</Title>
          <Text size="sm" c="dimmed">
            Noch ein Schritt: Unter diesem Namen legst du gleich die Profile deiner Kinder an.
          </Text>
          {error ? (
            <Alert color="red" variant="light">
              {error}
            </Alert>
          ) : null}
          <TextInput
            label="Name der Familie"
            placeholder="Familie Weber"
            value={name}
            onChange={(e) => setName(e.currentTarget.value)}
          />
          <TextInput
            label="Dein Name"
            description="So stehst du in der Familie."
            placeholder="Mama"
            value={displayName}
            onChange={(e) => setDisplayName(e.currentTarget.value)}
          />
          <Button disabled={!name || !displayName || busy} loading={busy} onClick={go}>
            Familie anlegen
          </Button>
          <Button variant="subtle" color="gray" onClick={unpair}>
            Abmelden
          </Button>
          <Anchor component={Link} to="/datenschutz" size="xs" c="dimmed">
            Datenschutz
          </Anchor>
        </Stack>
      </Card>
    </Center>
  );
}
